module.exports = __webpack_public_path__ + "img/up_1.6dbf1eef.png";